"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_TO_CURRENCY = void 0;
const currencies_1 = require("./currencies");
exports.COUNTRY_TO_CURRENCY = {
    AD: currencies_1.CurrencyCodes.EURO,
    AE: currencies_1.CurrencyCodes.UNITED_ARAB_EMIRATES_DIRHAM,
    AF: currencies_1.CurrencyCodes.AFGHAN_AFGHANI,
    AG: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    AI: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    AL: currencies_1.CurrencyCodes.ALBANIAN_LEK,
    AM: currencies_1.CurrencyCodes.ARMENIAN_DRAM,
    AO: currencies_1.CurrencyCodes.ANGOLAN_KWANZA,
    AQ: null,
    AR: currencies_1.CurrencyCodes.ARGENTINE_PESO,
    AS: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    AT: currencies_1.CurrencyCodes.EURO,
    AU: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    AW: currencies_1.CurrencyCodes.ARUBAN_FLORIN,
    AX: currencies_1.CurrencyCodes.EURO,
    AZ: currencies_1.CurrencyCodes.AZERBAIJANI_MANAT,
    BA: currencies_1.CurrencyCodes.BOSNIA_AND_HERZEGOVINA_CONVERTIBLE_MARK,
    BB: currencies_1.CurrencyCodes.BARBADIAN_DOLLAR,
    BD: currencies_1.CurrencyCodes.BANGLADESHI_TAKA,
    BE: currencies_1.CurrencyCodes.EURO,
    BF: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    BG: currencies_1.CurrencyCodes.EURO,
    BH: currencies_1.CurrencyCodes.BAHRAINI_DINAR,
    BI: currencies_1.CurrencyCodes.BURUNDIAN_FRANC,
    BJ: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    BL: currencies_1.CurrencyCodes.EURO,
    BM: currencies_1.CurrencyCodes.BERMUDIAN_DOLLAR,
    BN: currencies_1.CurrencyCodes.BRUNEI_DOLLAR,
    BO: currencies_1.CurrencyCodes.BOLIVIAN_BOLIVIANO,
    BQ: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    BR: currencies_1.CurrencyCodes.BRAZILIAN_REAL,
    BS: currencies_1.CurrencyCodes.BAHAMIAN_DOLLAR,
    BT: currencies_1.CurrencyCodes.BHUTANESE_NGULTRUM,
    BV: currencies_1.CurrencyCodes.NORWEGIAN_KRONA,
    BW: currencies_1.CurrencyCodes.BOTSWANA_PULA,
    BY: currencies_1.CurrencyCodes.BELARUSIAN_RUBLE,
    BZ: currencies_1.CurrencyCodes.BELIZE_DOLLAR,
    CA: currencies_1.CurrencyCodes.CANADIAN_DOLLAR,
    CC: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    CD: currencies_1.CurrencyCodes.CONGOLESE_FRANC,
    CF: currencies_1.CurrencyCodes.CENTRAL_AFRICAN_FRANC,
    CG: currencies_1.CurrencyCodes.CENTRAL_AFRICAN_FRANC,
    CH: currencies_1.CurrencyCodes.SWISS_FRANC,
    CI: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    CK: currencies_1.CurrencyCodes.NEW_ZEALAND_DOLLAR,
    CL: currencies_1.CurrencyCodes.CHILEAN_PESO,
    CM: currencies_1.CurrencyCodes.CENTRAL_AFRICAN_FRANC,
    CN: currencies_1.CurrencyCodes.CHINESE_YUAN,
    CO: currencies_1.CurrencyCodes.COLOMBIAN_PESO,
    CR: currencies_1.CurrencyCodes.COSTA_RICAN_COLON,
    CU: currencies_1.CurrencyCodes.CUBAN_PESO,
    CV: currencies_1.CurrencyCodes.CABO_VERDEAN_ESCUDO,
    // TODO: replace with CurrencyCodes.CARIBBEAN_GUILDER ("XCG")
    CW: currencies_1.CurrencyCodes.NETHERLANDS_ANTILLEAN_GUILDER,
    CX: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    CY: currencies_1.CurrencyCodes.EURO,
    CZ: currencies_1.CurrencyCodes.CZECH_KORUNA,
    DE: currencies_1.CurrencyCodes.EURO,
    DJ: currencies_1.CurrencyCodes.DJIBOUTIAN_FRANC,
    DK: currencies_1.CurrencyCodes.DANISH_KRONA,
    DM: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    DO: currencies_1.CurrencyCodes.DOMINICAN_PESO,
    DZ: currencies_1.CurrencyCodes.ALGERIAN_DINAR,
    EC: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    EE: currencies_1.CurrencyCodes.EURO,
    EG: currencies_1.CurrencyCodes.EGYPTIAN_POUND,
    EH: currencies_1.CurrencyCodes.MOROCCAN_DIRHAM,
    ER: currencies_1.CurrencyCodes.ERITREAN_NAKFA,
    ES: currencies_1.CurrencyCodes.EURO,
    ET: currencies_1.CurrencyCodes.ETHIOPIAN_BIRR,
    FI: currencies_1.CurrencyCodes.EURO,
    FJ: currencies_1.CurrencyCodes.FIJIAN_DOLLAR,
    FK: currencies_1.CurrencyCodes.FALKLAND_ISLANDS_POUND,
    FM: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    FO: currencies_1.CurrencyCodes.DANISH_KRONA,
    FR: currencies_1.CurrencyCodes.EURO,
    GA: currencies_1.CurrencyCodes.CENTRAL_AFRICAN_FRANC,
    GB: currencies_1.CurrencyCodes.POUND_STERLING,
    GD: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    GE: currencies_1.CurrencyCodes.GEORGIAN_LARI,
    GF: currencies_1.CurrencyCodes.EURO,
    GG: currencies_1.CurrencyCodes.POUND_STERLING,
    GH: currencies_1.CurrencyCodes.GHANIAN_CEDI,
    GI: currencies_1.CurrencyCodes.GIBRALTAR_POUND,
    GL: currencies_1.CurrencyCodes.DANISH_KRONA,
    GM: currencies_1.CurrencyCodes.GAMBIAN_DALASI,
    GN: currencies_1.CurrencyCodes.GUINEAN_FRANC,
    GP: currencies_1.CurrencyCodes.EURO,
    GQ: currencies_1.CurrencyCodes.CENTRAL_AFRICAN_FRANC,
    GR: currencies_1.CurrencyCodes.EURO,
    GS: currencies_1.CurrencyCodes.POUND_STERLING,
    GT: currencies_1.CurrencyCodes.GUATEMALAN_QUETZAL,
    GU: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    GW: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    GY: currencies_1.CurrencyCodes.GUYANESE_DOLLAR,
    HK: currencies_1.CurrencyCodes.HONG_KONG_DOLLAR,
    HM: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    HN: currencies_1.CurrencyCodes.HONDURAN_LEMPIRA,
    HR: currencies_1.CurrencyCodes.EURO,
    HT: currencies_1.CurrencyCodes.HAITIAN_GOURDE,
    HU: currencies_1.CurrencyCodes.HUNGARIAN_FORINT,
    ID: currencies_1.CurrencyCodes.INDONESIAN_RUPIAH,
    IE: currencies_1.CurrencyCodes.EURO,
    IL: currencies_1.CurrencyCodes.ISRAELI_NEW_SHEKEL,
    IM: currencies_1.CurrencyCodes.POUND_STERLING,
    IN: currencies_1.CurrencyCodes.INDIAN_RUPEE,
    IO: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    IQ: currencies_1.CurrencyCodes.IRAQI_DINAR,
    IR: currencies_1.CurrencyCodes.IRANIAN_RIAL,
    IS: currencies_1.CurrencyCodes.ICELANDIC_KRONA,
    IT: currencies_1.CurrencyCodes.EURO,
    JE: currencies_1.CurrencyCodes.POUND_STERLING,
    JM: currencies_1.CurrencyCodes.JAMAICAN_DOLLAR,
    JO: currencies_1.CurrencyCodes.JORDANIAN_DOLLAR,
    JP: currencies_1.CurrencyCodes.JAPANESE_YEN,
    KE: currencies_1.CurrencyCodes.KENYAN_SHILLING,
    KG: currencies_1.CurrencyCodes.KYRGYZSTANI_SOM,
    KH: currencies_1.CurrencyCodes.CAMBODIAN_RIEL,
    KI: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    KM: currencies_1.CurrencyCodes.COMORIAN_FRANC,
    KN: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    KP: currencies_1.CurrencyCodes.NORTH_KOREAN_WON,
    KR: currencies_1.CurrencyCodes.SOUTH_KOREAN_WON,
    KW: currencies_1.CurrencyCodes.KUWAITI_DINAR,
    KY: currencies_1.CurrencyCodes.CAYMAN_ISLANDS_DOLLAR,
    KZ: currencies_1.CurrencyCodes.KAZAKHSTANI_TENGE,
    LA: currencies_1.CurrencyCodes.LAO_KIP,
    LB: currencies_1.CurrencyCodes.LEBANESE_POUND,
    LC: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    LI: currencies_1.CurrencyCodes.SWISS_FRANC,
    LK: currencies_1.CurrencyCodes.SRI_LANKAN_RUPEE,
    LR: currencies_1.CurrencyCodes.LIBERIAN_DOLLAR,
    LS: currencies_1.CurrencyCodes.LESOTHO_LOTI,
    LT: currencies_1.CurrencyCodes.EURO,
    LU: currencies_1.CurrencyCodes.EURO,
    LV: currencies_1.CurrencyCodes.EURO,
    LY: currencies_1.CurrencyCodes.LIBYAN_DINAR,
    MA: currencies_1.CurrencyCodes.MOROCCAN_DIRHAM,
    MC: currencies_1.CurrencyCodes.EURO,
    MD: currencies_1.CurrencyCodes.MOLDOVAN_LEU,
    ME: currencies_1.CurrencyCodes.EURO,
    MF: currencies_1.CurrencyCodes.EURO,
    MG: currencies_1.CurrencyCodes.MALAGASY_ARIARY,
    MH: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    MK: currencies_1.CurrencyCodes.MACEDONIAN_DENAR,
    ML: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    MM: currencies_1.CurrencyCodes.MYANMAR_KYAT,
    MN: currencies_1.CurrencyCodes.MONGOLIAN_TOGROG,
    MO: currencies_1.CurrencyCodes.MACANESE_PATACA,
    MP: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    MQ: currencies_1.CurrencyCodes.EURO,
    MR: currencies_1.CurrencyCodes.MAURITANIAN_OUGUIYA,
    MS: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    MT: currencies_1.CurrencyCodes.EURO,
    MU: currencies_1.CurrencyCodes.MAURITANIAN_RUPEE,
    MV: currencies_1.CurrencyCodes.MALDIVIAN_RUFIYAA,
    MW: currencies_1.CurrencyCodes.MALAWIAN_KWACHA,
    MX: currencies_1.CurrencyCodes.MEXICAN_PESO,
    MY: currencies_1.CurrencyCodes.MALAYSIAN_RINGGIT,
    MZ: currencies_1.CurrencyCodes.MOZAMBICAN_METICAL,
    NA: currencies_1.CurrencyCodes.NAMIBIAN_DOLLAR,
    NC: currencies_1.CurrencyCodes.CFP_FRANC,
    NE: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    NF: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    NG: currencies_1.CurrencyCodes.NIGERIAN_NAIRA,
    NI: currencies_1.CurrencyCodes.NICARAGUAN_CORDOBA,
    NL: currencies_1.CurrencyCodes.EURO,
    NO: currencies_1.CurrencyCodes.NORWEGIAN_KRONA,
    NP: currencies_1.CurrencyCodes.NEPALESE_RUPEE,
    NR: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    NU: currencies_1.CurrencyCodes.NEW_ZEALAND_DOLLAR,
    NZ: currencies_1.CurrencyCodes.NEW_ZEALAND_DOLLAR,
    OM: currencies_1.CurrencyCodes.OMANI_RIAL,
    PA: currencies_1.CurrencyCodes.PANAMANIAN_BALBOA,
    PE: currencies_1.CurrencyCodes.PERUVIAN_SOL,
    PF: currencies_1.CurrencyCodes.CFP_FRANC,
    PG: currencies_1.CurrencyCodes.PAPUA_NEW_GUINEAN_KINA,
    PH: currencies_1.CurrencyCodes.PHILIPPINE_PESO,
    PK: currencies_1.CurrencyCodes.PAKISTANI_RUPEE,
    PL: currencies_1.CurrencyCodes.POLISH_ZLOTY,
    PM: currencies_1.CurrencyCodes.EURO,
    PN: currencies_1.CurrencyCodes.NEW_ZEALAND_DOLLAR,
    PR: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    PS: currencies_1.CurrencyCodes.ISRAELI_NEW_SHEKEL,
    PT: currencies_1.CurrencyCodes.EURO,
    PW: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    PY: currencies_1.CurrencyCodes.PARAGUAYAN_GUARANI,
    QA: currencies_1.CurrencyCodes.QATARI_RIYAL,
    RE: currencies_1.CurrencyCodes.EURO,
    RO: currencies_1.CurrencyCodes.ROMANIAN_LEU,
    RS: currencies_1.CurrencyCodes.SERBIAN_DINAR,
    RU: currencies_1.CurrencyCodes.RUSSIAN_RUBLE,
    RW: currencies_1.CurrencyCodes.RWANDAN_FRANC,
    SA: currencies_1.CurrencyCodes.SAUDI_RIYAL,
    SB: currencies_1.CurrencyCodes.SOLOMON_ISLANDS_DOLLAR,
    SC: currencies_1.CurrencyCodes.SEYCHELLOIS_RUPEE,
    SD: currencies_1.CurrencyCodes.SUDANESE_POUND,
    SE: currencies_1.CurrencyCodes.SWEDISH_KRONA,
    SG: currencies_1.CurrencyCodes.SINGAPORE_DOLLAR,
    SH: currencies_1.CurrencyCodes.SAINT_HELENA_POUND,
    SI: currencies_1.CurrencyCodes.EURO,
    SJ: currencies_1.CurrencyCodes.NORWEGIAN_KRONA,
    SK: currencies_1.CurrencyCodes.EURO,
    // TODO: enum value is currently "SLL"; current ISO code is "SLE"
    SL: currencies_1.CurrencyCodes.SIERRA_LEONEAN_LEONE,
    SM: currencies_1.CurrencyCodes.EURO,
    SN: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    SO: currencies_1.CurrencyCodes.SOMALI_SHILLING,
    SR: currencies_1.CurrencyCodes.SURINAMESE_DOLLAR,
    SS: currencies_1.CurrencyCodes.SOUTH_SUDANESE_POUND,
    ST: currencies_1.CurrencyCodes.SAO_TOME_AND_PRINCIPE_DOBRA,
    SV: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    // TODO: replace with CurrencyCodes.CARIBBEAN_GUILDER ("XCG")
    SX: currencies_1.CurrencyCodes.NETHERLANDS_ANTILLEAN_GUILDER,
    SY: currencies_1.CurrencyCodes.SYRIAN_POUND,
    SZ: currencies_1.CurrencyCodes.SWAZI_LILANGENI,
    TC: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    TD: currencies_1.CurrencyCodes.CENTRAL_AFRICAN_FRANC,
    TF: currencies_1.CurrencyCodes.EURO,
    TG: currencies_1.CurrencyCodes.WEST_AFRICAN_FRANC,
    TH: currencies_1.CurrencyCodes.THAI_BAHT,
    TJ: currencies_1.CurrencyCodes.TAJIKISTANI_SOMONI,
    TK: currencies_1.CurrencyCodes.NEW_ZEALAND_DOLLAR,
    TL: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    TM: currencies_1.CurrencyCodes.TURKMENISTAN_MANAT,
    TN: currencies_1.CurrencyCodes.TUNISIAN_DOLLAR,
    TO: currencies_1.CurrencyCodes.TONGAN_PAANGA,
    TR: currencies_1.CurrencyCodes.TURKISH_LIRA,
    TT: currencies_1.CurrencyCodes.TRINIDAD_AND_TOBAGO_DOLLAR,
    TV: currencies_1.CurrencyCodes.AUSTRALIAN_DOLLAR,
    TW: currencies_1.CurrencyCodes.NEW_TAIWAN_DOLLAR,
    TZ: currencies_1.CurrencyCodes.TANZANIAN_SHILLING,
    UA: currencies_1.CurrencyCodes.UKRAINIAN_HRYVNIA,
    UG: currencies_1.CurrencyCodes.UGANDAN_SHILLING,
    UM: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    US: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    UY: currencies_1.CurrencyCodes.URUGUAYAN_PESO,
    UZ: currencies_1.CurrencyCodes.UZBEKISTANI_SOM,
    VA: currencies_1.CurrencyCodes.EURO,
    VC: currencies_1.CurrencyCodes.EAST_CARIBBEAN_DOLLAR,
    VE: currencies_1.CurrencyCodes.VENEZUELAN_BOLIVAR_SOBERANO,
    VG: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    VI: currencies_1.CurrencyCodes.UNITED_STATES_DOLLAR,
    VN: currencies_1.CurrencyCodes.VIETNAMESE_DONG,
    VU: currencies_1.CurrencyCodes.VANUATU_VATU,
    WF: currencies_1.CurrencyCodes.CFP_FRANC,
    WS: currencies_1.CurrencyCodes.SAMOAN_TALA,
    YE: currencies_1.CurrencyCodes.YEMENI_RIAL,
    YT: currencies_1.CurrencyCodes.EURO,
    ZA: currencies_1.CurrencyCodes.SOUTH_AFRICAN_RAND,
    ZM: currencies_1.CurrencyCodes.ZAMBIAN_KWACHA,
    // TODO: enum value is currently "ZWL"; current ISO code is "ZWG"
    ZW: currencies_1.CurrencyCodes.ZIMBABWEAN_DOLLAR,
};
